import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import Close from "@material-ui/icons/Close";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Barcode from './assets/mdi_barcode_scan_black.svg';

const styles = {
  scanPopup: {
    width: "400px",
    minHeight: "230px",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: "14px",
    boxSizing: "border-box",
    '@media(max-width: 470px)': {
      width: "350px",
      padding: "16px 0",
    }
  },
  scanPopupNav: {
    width: "100%",
    height: "24px",
    display: "grid",
    gridTemplateColumns: "1fr 24px",
    placeItems: "center",
    marginBottom: "40px",
  },
  interactPanel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    '@media(max-width: 470px)': {
      width: "100%",
      padding: "0 4px"
    }
  },
  scanTitle: {
    display: "flex",
    alignItems: "center",
    "& div": {
      marginLeft: "8px",
    }
  },
  closeButton: {
    justifySelf: "end",
    alignSelf: "center",
    width: "24px",
    height: "24px",
    marginRight: "15px",
    "&:hover": {
      backgroundColor: "#f2f9fa",
      borderRadius: "2px",
      cursor: "pointer",
    }
  },
  input: {
    width: "352px",
    height: "44px",
    borderRadius: "2px",
    border: "1px solid #00000066",
    paddingLeft: "8px",
    marginTop: "8px",
    '@media(max-width: 470px)': {
      width: "100%",
    }
  },
  errorMsg: {
    color: "#eb3c39",
    fontSize: "14px",
  },
  buttonContainer: {
    marginTop: "40px",
    display: "flex",
    justifyContent: "space-between",
  },
  confirmBtn: {
    width: "122px",
    height: "36px",
    backgroundColor: "#5f00a0",
    borderRadius: "2px",
    border: "none",
    color: "white",
    marginLeft: "24px",
    fontWeight: "500",
    boxShadow: "0px 2px 2px #00000033",
  },
  cancelBtn: {
    width: "122px",
    height: "36px",
    backgroundColor: "white",
    borderRadius: "2px",
    border: "none",
    color: "#5f00a0",
    fontWeight: "500",
  },

};

const ScanPopup = (props) => {
  const { classes } = props;

  const [value, setValue] = React.useState("");

  const handleSetValue = e => {
    props.setScanError("")
    setValue(e.target.value)

    try {
      const jsonScan = JSON.parse(e.target.value)

      let pziId = jsonScan.pzi_id;
      let zoneId = jsonScan.zone_id;
      if (pziId) {
        validateInput(pziId.toString())
      } else if (zoneId) {
        validateInput(zoneId.toString())
      }

    } catch (error) {
    }
  }

  const validateInput = raw => {
    if (raw === undefined || raw === null) return;

    const input = raw.toString().trim();
    const prefixRegex = /^PZIID\s*:\s*/i;
    const hasPrefix = prefixRegex.test(input);

    let code;
    if (hasPrefix) {
      code = input.replace(prefixRegex, "").trim();

      if (/^[0-9]{7}$/.test(code) && code.endsWith("2")) {
        code = code.slice(0, 6);
      }
    } else {
      code = input;
    }

    if (!/^[0-9]{6}$/.test(code)) {
      return;
    }

    props.handleScanDialog(parseInt(code, 10));
  }


  const handleKeyDown = e => {
    if (e.key === "Enter" && value) {
      validateInput(value)
    }
  }

  return (
    <div className={classes.scanPopup}>
      <div className={classes.scanPopupNav}>
        <div className={classes.scanTitle}>
          <img src={Barcode} alt="Scan Product" />
          <div>{I18n.get("ready_scan").toUpperCase()}</div>
        </div>
        <div className={classes.closeButton}>
          <Close onClick={() => { props.setOpenScan(false); props.setScanError("") }} />
        </div>
      </div>
      <div className={classes.interactPanel}>
        <input
          className={classes.input}
          autoFocus
          id="user_input"
          onKeyDown={handleKeyDown}
          onInput={e => handleSetValue(e)}
        >
        </input>
        {props.errorMsg ? <div className={classes.errorMsg}>{props.errorMsg}</div> : null}
      </div>
      <div className={classes.buttonContainer}>
        <button
          className={classes.cancelBtn}
          type="button"
          onClick={() => { props.setOpenScan(false); props.setScanError("") }}>{I18n.get("site_cancel").toUpperCase()}</button>
        <button
          className={classes.confirmBtn}
          type="button"
          onClick={() => validateInput(value)}>{I18n.get("site_search").toUpperCase()}</button>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(ScanPopup))
);